import React, { type ReactElement } from 'react';

import classNames from 'classnames';

interface Props {
  type?: 'item' | 'section';
  itemClassName?: string;
  sectionClassName?: string;
}

export default function CardDivider({
  type = 'item',
  itemClassName,
  sectionClassName,
}: Props): ReactElement {
  const divider = {
    item: (
      <div
        className={classNames(
          'flex h-2 w-full items-center justify-center px-3',
          itemClassName
        )}
      >
        <span className=" h-[1px] w-full bg-silver-200 " />
      </div>
    ),

    section: (
      <div
        className={classNames(
          'mb-3 mt-2.5 flex h-4  w-full items-center justify-center px-0',
          sectionClassName
        )}
      >
        <span className=" h-2 w-full bg-gray-30" />
      </div>
    ),
  };

  return <>{divider[type]}</>;
}
